'use client';

import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import Icon, { IconName } from '@/components/ui/Icon';
import { typographyVariants } from '@/components/ui/typography';
import { pushAnalyticsEvent } from '@/lib/analyticsClientSide';
import { useOnboardingSteps } from './hooks/useOnboardingSteps';

export default function OnboardingChecklist({
  onOpenChange,
}: {
  onOpenChange?: (open: boolean) => void;
}) {
  const t = useTranslations('Dashboard.OnboardingChecklist.steps');
  const { onboardingSteps, handleStepClick } = useOnboardingSteps();

  return (
    <ul className='mt-5 w-full'>
      {onboardingSteps.map((step) => (
        <li
          key={step.id}
          className='w-full border-b border-neutral-200 text-left'
        >
          <Button
            variant='link'
            className={`${typographyVariants({ variant: 'h2' })} hover:bg-white-300 box-content h-[72px] w-full grow justify-start gap-0 rounded-none px-0 py-6 text-left font-semibold no-underline hover:font-semibold hover:no-underline disabled:text-gray-500 disabled:line-through ${step.completed ? 'text-neutral-600' : 'text-neutral-900'}`}
            disabled={step.completed}
            onClick={() => {
              handleStepClick(step);
              onOpenChange?.(false);
              pushAnalyticsEvent('Onboarding Checklist - step clicked', {
                step: step.id,
              });
            }}
          >
            <div className='mr-10 ml-2 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-black'>
              <Icon
                variant={step.completed ? IconName.Check : IconName.ArrowRight}
                className={step.completed ? 'bg-secondary' : ''}
                width={24}
                height={24}
              />
            </div>
            {t(`${step.id}`)}
          </Button>
        </li>
      ))}
    </ul>
  );
}
